export default __webpack_public_path__ + "static/triangle4-bcbd947aa4b6c643c32117b0c09423cf.svg";